// angular imports
import { Exclude, Type } from 'class-transformer';

// cc-common imports
import { Utils } from 'cc-common';

// model imports
import { UserNameDisplayResultDto } from '../../_models/user-name-display-result-dto';

// constant imports
import { BoardApprovalProcessConstants } from '../_constants/board-approval-process-constants';

export class BoardApprovalItemResultDto {
    process: string;
    processId: string;

    processIdDisplayText: string;
    description: string;

    communityId: number;
    community: string;

    allowAction: boolean;

    // Added action property to pass while calling notes API
    action: string;

    @Type(() => UserNameDisplayResultDto)
    userInfo: UserNameDisplayResultDto;

    @Type(() => Date)
    addedOn: Date;

    @Type(() => Date)
    dueDate: Date;
    daysRemaining: number;
    statusIndicator: string;

    status: string;
    documentCount: number;
    required: boolean;
    hasNotes: boolean;

    isFinalStatus: boolean;

    reference: string;
    customerId: string;

    // Transient Property for action for multiple selection.
    @Exclude()
    allowSelection: boolean;

    @Exclude()
    processDisplayText: string;

    get hasNotesDisplayText(): string {
        return Utils.isTrue(this.hasNotes) ? 'Yes' : 'No';
    }

    get requiredDisplayText(): string {
        return Utils.isTrue(this.required) ? 'Yes' : 'No';
    }

    get userNameDisplayText(): string {
        return Utils.notNullAndDefined(this.userInfo) ? this.userInfo.displayName : null;
    }

    get detailDisplayText(): string {
        let title: string = null;
        switch (this.process) {
            case BoardApprovalProcessConstants.ACC:
                title = 'ACC';
                break;
            case BoardApprovalProcessConstants.COLLECTIONS:
                title = 'AR Collections';
                break;
            case BoardApprovalProcessConstants.WF:
                title = 'AP Workflow';
                break;
        }
        return `View ${title} Details`;
    }
}
